import SecurityAuthView from "./view/security-auth-view";

export default SecurityAuthView;
